import { Project } from "../api";
import {IngestionMessage, MessageScope, ValidationMessageType} from "../asset-service-api";

export const getFileErrors = (project: Project) : IngestionMessage[] => {
    if (!project) return [];

    const resourcesWithErrors = project.resources?.filter(r => r.audioInfo?.error) ?? [];
    return resourcesWithErrors.map(r => {
        return {
            details: "Audio validation encountered an error.",
            message: r.audioInfo?.error,
            messageType: ValidationMessageType.Error,
            source: {
                scope: MessageScope.File,
                stage: "local",
                target: r.filename,
                id: "09179136-7151-4425-88c1-09b523f67615",
            },
        } as IngestionMessage;
    });
};
